import { Routes, Route } from "react-router-dom";
import Home from "./screens/Home";
import Course from "./screens/Course";
import Event114 from "./screens/Event114";
import Course114 from "./screens/Course114";

// ?Uni=23&Country=34&Course=

export default function NavigateRoute() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:eventId" element={<Event114 />} />

      <Route path="/course/:eventId" element={<Course114 />} />
      <Route path="/course" element={<Course />} />
    </Routes>
  );
}
